module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-07-3ed2ecee92da5ed1c119e3753629618e.jpg";